export default __webpack_public_path__ + "static/media/potencia_de_la_vida.4ad094ba.svg";